import { get as getDetail, getPlaceholder } from 'services/detail'
import { legacyBatchGet as getUserNodeInfo } from 'services/user-node-info'

export const GET_DETAIL_DATA = 'GET_DETAIL_DATA'
export const SET_DETAIL_DATA = 'SET_DETAIL_DATA'
export const SET_DETAIL_DATA_PLACEHOLDER = 'SET_DETAIL_DATA_PLACEHOLDER'
export const SET_DETAIL_ID_PATH_TYPE = 'SET_DETAIL_ID_PATH_TYPE'
export const SET_DETAIL_PROCESSING = 'SET_DETAIL_PROCESSING'
export const SET_DETAIL_USER_INFO_PROCESSING = 'SET_DETAIL_USER_INFO_PROCESSING'
export const SET_DETAIL_FEATURED_USER_INFO_PROCESSING = 'SET_DETAIL_FEATURED_USER_INFO_PROCESSING'
export const APPEND_DETAIL_DATA_USER_INFO = 'APPEND_DETAIL_DATA_USER_INFO'
export const APPEND_DETAIL_DATA_FEATURED_USER_INFO = 'APPEND_DETAIL_DATA_FEATURED_USER_INFO'
export const DELETE_DETAIL_DATA_USER_INFO = 'DELETE_DETAIL_DATA_USER_INFO'
export const RESET_DETAIL_DATA = 'RESET_DETAIL_DATA'
export const GET_DETAIL_RELATED_CONTENT = 'GET_DETAIL_RELATED_CONTENT'
export const SET_DETAIL_RELATED_CONTENT_PROCESSING = 'SET_DETAIL_RELATED_CONTENT_PROCESSING'
export const SET_DETAIL_RELATED_CONTENT_DATA = 'SET_DETAIL_RELATED_CONTENT_DATA'
export const SET_SERIES_DETAIL_DATA = 'SET_SERIES_DETAIL_DATA'
export const SET_FEATURED_EPISODE_DATA = 'SET_FEATURED_EPISODE_DATA'
export const SET_DETAIL_MEDIA_INFO_DATA = 'SET_DETAIL_MEDIA_INFO_DATA'
export const SET_DETAIL_RELATED_VIDEO = 'SET_DETAIL_RELATED_VIDEO'
export const GET_SEASON_EPISODES = 'GET_SEASON_EPISODES'

export function getDetailData (options) {
  const {
    id, path, type, auth, language, include4kImages, include2kImages,
  } = options
  return function getDetailDataThunk (dispatch) {
    dispatch(setDetailIdPathType(id, path, type))
    return getDetail({
      id,
      auth,
      language,
      include2kImages,
      include4kImages,
    }).then((data) => {
      dispatch(setDetailData(data))
      return data
    })
  }
}

export function resetDetailData () {
  return {
    type: RESET_DETAIL_DATA,
    payload: {},
  }
}

export function setDetailData (data, processing = false) {
  return {
    type: SET_DETAIL_DATA,
    payload: { data, processing },
  }
}

export function setDetailDataPlaceholder (processing = true) {
  return {
    type: SET_DETAIL_DATA_PLACEHOLDER,
    payload: { data: getPlaceholder(), processing },
  }
}

export function setDetailIdPathType (id, path, type, processing = true) {
  return {
    type: SET_DETAIL_ID_PATH_TYPE,
    payload: {
      id, path, type, processing,
    },
  }
}

export function setDetailProcessing (value) {
  return {
    type: SET_DETAIL_PROCESSING,
    payload: value,
  }
}

export function setDetailUserInfoProcessing (value) {
  return {
    type: SET_DETAIL_USER_INFO_PROCESSING,
    payload: value,
  }
}

export function setDetailFeaturedUserInfoProcessing (value) {
  return {
    type: SET_DETAIL_FEATURED_USER_INFO_PROCESSING,
    payload: value,
  }
}

export function getDetailDataUserInfo (ids, auth) {
  return function getDetailDataUserInfoThunk (dispatch) {
    dispatch(setDetailUserInfoProcessing(true))
    return getUserNodeInfo({ ids, auth }).then((data) => {
      dispatch(appendDetailDataUserInfo(data))
      return data
    })
  }
}

export function getDetailDataFeaturedUserInfo (ids, auth) {
  return function getDetailDataFeaturedUserInfoThunk (dispatch) {
    dispatch(setDetailFeaturedUserInfoProcessing(true))
    return getUserNodeInfo({ ids, auth }).then((data) => {
      dispatch(appendDetailDataFeaturedUserInfo(data))
      return data
    })
  }
}

export function appendDetailDataUserInfo (userInfo, userInfoProcessing = false) {
  return {
    type: APPEND_DETAIL_DATA_USER_INFO,
    payload: { userInfo, userInfoProcessing },
  }
}

export function appendDetailDataFeaturedUserInfo (
  userInfo,
  featuredUserInfoProcessing = false,
) {
  return {
    type: APPEND_DETAIL_DATA_FEATURED_USER_INFO,
    payload: { userInfo, featuredUserInfoProcessing },
  }
}

export function deleteDetailDataUserInfo () {
  return {
    type: DELETE_DETAIL_DATA_USER_INFO,
  }
}

export function getDetailRelatedContent (options = {}) {
  return {
    type: GET_DETAIL_RELATED_CONTENT,
    payload: options,
  }
}

export function setDetailRelatedContentProcessing (processing) {
  return {
    type: SET_DETAIL_RELATED_CONTENT_PROCESSING,
    payload: processing,
  }
}

export function setDetailRelatedContentData (data, processing = false) {
  return {
    type: SET_DETAIL_RELATED_CONTENT_DATA,
    payload: { data, processing },
  }
}

export function setDetailRelatedVideo (data) {
  return {
    type: SET_DETAIL_RELATED_VIDEO,
    payload: { data },
  }
}
export function setSeriesDetailData (data) {
  return {
    type: SET_SERIES_DETAIL_DATA,
    payload: { data },
  }
}

export function setFeaturedEpisodeData (data) {
  return {
    type: SET_FEATURED_EPISODE_DATA,
    payload: { data },
  }
}

export function setDetailMediaInfoData (data) {
  return {
    type: SET_DETAIL_MEDIA_INFO_DATA,
    payload: { data },
  }
}

export function getSeasonEpisodes ({ season, updateData, page }) {
  return {
    type: GET_SEASON_EPISODES,
    payload: { season, updateData, page },
  }
}
